import { render } from "./CompraDetalle.vue?vue&type=template&id=51410aae&scoped=true"
import script from "./CompraDetalle.vue?vue&type=script&lang=js"
export * from "./CompraDetalle.vue?vue&type=script&lang=js"

import "./CompraDetalle.vue?vue&type=style&index=0&id=51410aae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51410aae"]])

export default __exports__